module.exports = __webpack_public_path__ + "img/12dbafa.jpg";